import { API_URL } from 'utils/environmentVariables';

export const PRIVACY_POLICY_URL = 'https://global.com/legal/privacy-policy/';
export const FOOTER_LINKS = [
  {
    label: 'Privacy Policy',
    href: PRIVACY_POLICY_URL,
  },
];

export const DEFAULT_TITLE = 'DAX Inventory';

export const HOME_PAGE_URL = '/';

export const DRAFTS_API_URL = `${API_URL}/api/v1/drafts`;
export const DRAFTS_COUNT_API_URL = `${DRAFTS_API_URL}/count`;
export const DRAFTS_SYNCING_API_URL = `${DRAFTS_API_URL}/status/syncing`;
export const DRAFTS_READY_API_URL = `${DRAFTS_API_URL}/status/ready`;
export const DRAFTS_ERROR_API_URL = `${DRAFTS_API_URL}/status/error`;
export const DRAFTS_SYNC_API_URL = `${DRAFTS_API_URL}/sync`;
export const DRAFTS_EXPORT_API_URL = `${DRAFTS_API_URL}/export`;

export const FRAMES_API_URL = `${API_URL}/api/v1/frames`;
export const FRAMES_ARCHIVE_API_URL = `${FRAMES_API_URL}/archive`;
export const FRAMES_UNARCHIVE_API_URL = `${FRAMES_API_URL}/unarchive`;
export const FRAMES_ACTIVATE_API_URL = `${FRAMES_API_URL}/activate`;
export const FRAMES_DEACTIVATE_API_URL = `${FRAMES_API_URL}/deactivate`;

export const LINKED_ASSETS_API_URL = `${API_URL}/api/v1/linked-assets`;
export const LINKED_ASSETS_ARCHIVE_API_URL = `${LINKED_ASSETS_API_URL}/archive`;
export const LINKED_ASSETS_UNARCHIVE_API_URL = `${LINKED_ASSETS_API_URL}/unarchive`;
export const LINKED_ASSETS_ACTIVATE_API_URL = `${LINKED_ASSETS_API_URL}/activate`;
export const LINKED_ASSETS_DEACTIVATE_API_URL = `${LINKED_ASSETS_API_URL}/deactivate`;

export const DATA_MANAGEMENT_DATA_API_URL = `${API_URL}/api/v1/data`;
export const FRAME_SERVICE_API_URL = `${API_URL}/api/v1/frame-service`;
export const TASKS_API_URL = `${API_URL}/api/v1/tasks`;

export const FRAMES_PAGE_URL = '/frames';
export const LINKED_ASSETS_PAGE_URL = '/linked-assets';
export const DRAFTS_PAGE_URL = '/drafts';
export const DATA_MANAGEMENT_PAGE_URL = '/data-management';
export const ENTITY_PAGE_URL = '/entities';

export const DEFAULT_STATUS_INDICATOR_SIZE = '8px';
export const DEFAULT_TABLE_PAGE_SIZE = 20;
export const DEFAULT_TABLE_GRID_TEMPLATE = '40px 104px 1fr 200px 150px 120px';
export const SEARCH_RESULTS_LIMIT = 5;
export const SEARCH_TERM = 'searchTerm';

export const ENTITY_API_URL = `${API_URL}/api/v1/live-entities`;
export const ENTITY_SEARCH_API_URL = `${ENTITY_API_URL}/search`;
export const ENTITY_ARCHIVE_API_URL = `${ENTITY_API_URL}/archive`;
export const ENTITY_UNARCHIVE_API_URL = `${ENTITY_API_URL}/unarchive`;
export const ENTITY_ACTIVATE_API_URL = `${ENTITY_API_URL}/activate`;
export const ENTITY_DEACTIVATE_API_URL = `${ENTITY_API_URL}/deactivate`;
export const ENTITY_ACTIONS_API_URL = `${ENTITY_API_URL}/available-actions`;
export const IMPORT_API_URL = `${API_URL}/api/v1/import`;
export const FILTERS_API_URL = `${API_URL}/api/v1/filters`;

export const IMPORT_DIALOG_ID = 'import';
export const ENTITIES_PAGE_ACTION_DIALOG_ID = 'entitiesPageAction';
export const ENTITIES_PAGE_RESULT_DIALOG_ID = 'entitiesPageResult';
export const ENTITIES_PAGE_CONFIRMATION_DIALOG_ID = 'entitiesPageConfirmation';
export const ENTITIES_PAGE_BULK_CONFIRMATION_DIALOG_BY_FILTER_ID = 'entitiesPageConfirmationBulk';
export const DRAFTS_PAGE_REMOVE_DIALOG_ID = 'draftsPageRemove';
export const DRAFTS_PAGE_SYNC_DIALOG_ID = 'draftsPageSync';
export const ENTITY_ACTION_DIALOG_ID = 'entityAction';
export const FILE_UPLOAD_DIALOG_ID = 'fileUpload';
export const FILE_UPLOAD_RESULT_DIALOG_ID = 'fileUploadResult';
export const BACKSPACE = 'Backspace';
export const ENTER = 'Enter';
export const SPACE = ' ';
export const COMMA = ',';

export const APPLICATION_JSON = 'application/json';
export const APPLICATION_CSV = 'application/csv';
export const APPLICATION_ZIP = 'application/zip';
